import React, { Component, Fragment } from "react";
import BasicLayout from "layouts/BasicLayout";
import PageHeaderLayout from "layouts/PageHeaderLayout";
import {
	Card,
	Spin,
	Row,
	Button,
	Form,
	Popconfirm,
	Icon,
	Dropdown,
	Menu,
	message,
	Upload
} from "antd";
import "ag-grid/dist/styles/ag-grid.css";
import "ag-grid/dist/styles/ag-theme-balham.css";
import { AgGridReact } from "ag-grid-react";
import { locationPrefix } from "common/general";
import { autorun } from "mobx";
import { inject, observer } from "mobx-react";

import ImportPrivatesitesDialog from "./components/ImportPrivateSitesDialog";
import ImportFromAccountProfileDialog from "./components/ImportFromAccountProfileDialog";

const FormItem = Form.Item;

var privateSiteEmailRenderer = function(params) {
	if (params.node.group == true) {
		return null;
	}
	if (params.value) {
		var parts = params.value.split("|");
		if (parts.length > 0) {
			return "<span>" + parts[0] + "</span>";
		}
		return "";
	} else {
		return "";
	}
}

@inject("rootStore")
@observer
class PrivateNetworkPage extends Component {
	collapseAll = () => {
		this.gridApi.collapseAll();
	};

	expandAll = () => {
		this.gridApi.expandAll();
	};

	onGridReady = params => {
		this.gridApi = params.api;
		this.gridColumnApi = params.columnApi;

		const {
			rootStore: { privateNetworkStore }
		} = this.props;

		const ui = privateNetworkStore.ui;

		this.importPrivateSitesDisposer = autorun(() => {
			// console.log("Importing private sites");
			let updatedPrivateSites = [];
			let newPrivateSites = [];
			for (let privateSite of ui.importedPrivateSites) {
				let tmp = {
					id: {
						networkGroupId: privateSite.privateGroupId,
						siteId: privateSite.siteId,
						email: privateSite.email
					},
					group: privateSite.group,
					platform: privateSite.platform,
					siteUrl: privateSite.siteUrl,
					password: privateSite.password,
					username: privateSite.username
				};

				const currentAccount = this.gridApi.getRowNode(
					tmp.id.siteId + "_" + tmp.id.email
				);
				if (currentAccount == null) {
					newPrivateSites.push(tmp);
				} else {
					updatedPrivateSites.push(tmp);
				}
			}
			this.gridApi.updateRowData({
				add: newPrivateSites,
				update: updatedPrivateSites
			});
		});

		this.deletePrivateSitesDisposer = autorun(() => {
			if (ui.deletedPrivateSites != null) {
				let deletedPrivateSites = ui.deletedPrivateSites.map(
					deletedPrivateSite => {
						return {
							id: {
								group: deletedPrivateSite.group,
								siteId: deletedPrivateSite.siteId,
								email: deletedPrivateSite.email
							}
						};
					}
				);

				this.gridApi.updateRowData({
					remove: deletedPrivateSites
				});
			}
		});
	};

	createGridDefs(columnDefs) {
		const gridDefs = {
			columnDefs: [
				{
					headerName: "Module",
					field: "group",
					editable: false,
					hide: true,
					rowGroupIndex: 0
				},
				{
					headerName: "Platform",
					field: "platform",
					editable: false,
					hide: false,
					rowGroupIndex: 1
				},
				{
					headerName: "Site URL",
					field: "siteUrl",
					editable: false,
					filter: "agTextColumnFilter"
				},
				{
					headerName: "Email",
					field: "id.email",
					editable: false,
					filter: "agTextColumnFilter",
					cellRenderer: privateSiteEmailRenderer
				},
				{
					headerName: "Username",
					field: "username",
					editable: false,
					filter: "agTextColumnFilter"
				},
				{
					headerName: "Password",
					field: "password",
					editable: false,
					suppressFilter: true
				}
			],
			groupDefaultExpanded: -1,
			autoGroupColumnDef: {
				headerName: "Site",
				field: "id.siteId",
				filter: "agTextColumnFilter",
				headerCheckboxSelection: () => {
					return true;
				},
				headerCheckboxSelectionFilteredOnly: true,
				width: 300,
				editable: false,
				cellRenderer: "agGroupCellRenderer",
				cellRendererParams: {
					checkbox: true,
					readOnly: () => {
						return false;
					}
				},
				suppressSorting: true
			},
			rowSelection: "multiple"
		};
		return gridDefs;
	}

	deletePrivateSites = () => {
		const {
			rootStore: { privateNetworkStore }
		} = this.props;

		if (this.gridApi != null) {
			let privateSiteIds = [];
			for (let node of this.gridApi.getSelectedNodes()) {
				const privateSite = node.data;
				privateSiteIds.push({
					group: privateSite.group,
					siteId: privateSite.id.siteId,
					email: privateSite.id.email
				});
			}
			privateNetworkStore.remoteDeletePrivateSites(privateSiteIds);
		}
	};

	onRowSelected = event => {
		if (event.node.group == false) {
			event.data.checked = event.node.selected;
		}
	};

	componentWillUnmount() {
		if (this.deletePrivateSitesDisposer != null) {
			this.deletePrivateSitesDisposer();
		}
		if (this.importPrivateSitesDisposer != null) {
			this.importPrivateSitesDisposer();
		}
		// if (this.newPrivateSiteDisposer != null) {
		// 	this.newPrivateSiteDisposer();
		// }
		// if (this.updatePrivateSiteDisposer != null) {
		// 	this.updatePrivateSiteDisposer();
		// }
		// if (this.importPrivateSiteDisposer != null) {
		// 	this.importPrivateSiteDisposer();
		// }
	}

	showImportPrivateSitesDialog = () => {
		const {
			rootStore: { privateNetworkStore }
		} = this.props;

		privateNetworkStore.showImportPrivateSitesDialog();
	};

	showImportFromAccountProfileDialog = () => {
		const {
			rootStore: { privateNetworkStore }
		} = this.props;

		privateNetworkStore.showImportFromAccountProfileDialog();
	};

	handleImportMenuClick = ({ key }) => {
		if (key == "bulkImport") {
			this.showImportPrivateSitesDialog();
		}
		if (key == "importFromProfile") {
			this.showImportFromAccountProfileDialog();
		}
	};

	render() {
		const {
			rootStore: { privateNetworkStore }
		} = this.props;

		const ui = privateNetworkStore.ui;
		const privateNetwork = privateNetworkStore.privateNetwork;

		let breadcrumbList = "";

		if (!ui.loadingPrivateNetwork) {
			breadcrumbList = [
				{
					title: "Home",
					href: locationPrefix + "/"
				},
				{
					title: "Private Networks",
					href: locationPrefix + "/private-networks"
				},
				{
					title: privateNetwork.name
				}
			];
		}

		let spinning =
			ui.loadingPrivateNetwork == true || ui.deletingPrivateSites == true;
		const gridDefs = this.createGridDefs();

		const importMenu = (
			<Menu onClick={this.handleImportMenuClick}>
				<Menu.Item key="bulkImport">Manually</Menu.Item>
				<Menu.Item key="importFromProfile">
					From Account Profiles
				</Menu.Item>
			</Menu>
		);

		const treeData = privateNetworkStore.profiles.slice();

		return (
			<Fragment>
				{ui.loadingPrivateNetwork == true ? (
					""
				) : (
					<PageHeaderLayout
						breadcrumbList={breadcrumbList}
						title={
							"Private Network: " +
							privateNetworkStore.privateNetwork.name
						}
					>
						<Card>
							<Spin spinning={spinning}>
								<ImportPrivatesitesDialog />
								<ImportFromAccountProfileDialog
									treeData={treeData}
								/>
								<Row>
									<Form layout="inline">
										<FormItem>
											<Button
												type="primary"
												onClick={this.collapseAll}
											>
												Collapse
											</Button>
										</FormItem>
										<FormItem>
											<Button
												type="primary"
												onClick={this.expandAll}
											>
												Expand
											</Button>
										</FormItem>
										<FormItem>
											<Dropdown overlay={importMenu}>
												<Button type="primary">
													Import
												</Button>
											</Dropdown>
										</FormItem>
										<FormItem>
											<Popconfirm
												title="Delete the selected private network sites?"
												place
												ment="bottom"
												onConfirm={
													this.deletePrivateSites
												}
											>
												<Button type="primary">
													<Icon type="delete" />
												</Button>
											</Popconfirm>
										</FormItem>
									</Form>
								</Row>
								<br />
								<Row>
									<div
										style={{
											width: "100%",
											height:
												(window.screen.height * 3) / 4
										}}
									>
										<div
											style={{
												boxSizing: "border-box",
												height: "100%",
												width: "100%"
											}}
											className="ag-theme-balham"
										>
											<AgGridReact
												columnDefs={gridDefs.columnDefs}
												enableColResize={true}
												enableFilter={true}
												floatingFilter={true}
												enableSorting={true}
												groupSelectsChildren={true}
												groupDefaultExpanded={
													gridDefs.groupDefaultExpanded
												}
												autoGroupColumnDef={
													gridDefs.autoGroupColumnDef
												}
												rowData={
													privateNetworkStore.sites.slice()
												}
												enableRangeSelection={true}
												rowSelection={
													gridDefs.rowSelection
												}
												suppressRowClickSelection={true}
												getRowNodeId={data => {
													return (
														data.id.siteId +
														"_" +
														data.id.email
													);
												}}
												onSortChanged={e => {
													// console.log(
													// 	e.api.getSortModel()
													// );
												}}
												deltaRowDataMode={true}
												onGridReady={this.onGridReady}
											/>
										</div>
									</div>
								</Row>
							</Spin>
						</Card>
					</PageHeaderLayout>
				)}
			</Fragment>
		);
	}
}

export default PrivateNetworkPage;
